import React from "react";

import { Theme, Typography, FormControl, Select, SelectProps, MenuItem, Collapse } from "@mui/material";
import { SxProps } from "@mui/system/styleFunctionSx/styleFunctionSx";
import { StyledAlert } from ".";
// import BackDrop from "./BackDrop";
// import { array } from "yup/lib/locale";

const root: SxProps<Theme> = {
  height: "40px",
  backgroundColor: "common.white",
  "&:hover": {
    backgroundColor: theme => theme.palette.grey[200],
    borderColor: theme => theme.palette.grey[200],
  },
  ".Mui-disabled": {
    backgroundColor: theme => theme.palette.grey[100],
    lineHeight: "40px"
  },
  "& .MuiSelect-outlined": {
    padding: "0 0 0 12px",
  },
  "& .MuiOutlinedInput-notchedOutline.MuiOutlinedInput-notchedOutline": {
    border: theme => "1px solid " + theme.palette.grey[300],
  },
  "&:hover .MuiOutlinedInput-notchedOutline.MuiOutlinedInput-notchedOutline": {
    border: theme => "1px solid " + theme.palette.grey[300],
    borderRadius: "4px",
  },
  "& .MuiSelect-select": {
    color: theme => theme.palette.text.primary,
  },
  "& .mui-select-placeholder": {
    color: theme => theme.palette.grey[500],
  }
};
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "450px",
    },
  },
};

interface Props {
  height?: string;
  showErrorMessage?: boolean;
  helperText?: string | any;
  showLabel?: boolean;
  required?: boolean;
  labelChild?: any;
  items: { name: string; value: string | number }[];
  loading?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
  controlSx?: SxProps<Theme>;
}

const SelectWithLabel: React.FC<Props & SelectProps> = ({
  showErrorMessage = true,
  error,
  helperText,
  showLabel,
  label,
  items,
  value,
  required,
  labelChild,
  onChange,
  height,
  loading,
  placeholder,
  fullWidth = true,
  controlSx,
  ...rest
}) => {
  return (
    <FormControl fullWidth={fullWidth} sx={controlSx} size={rest.size}>
      {showLabel && (
        <Typography fontWeight="600" pb="8px">
          {label}
          {required && (
            <Typography component="span" fontWeight="600" color="error" sx={{ ml: "3px" }}>
              *
            </Typography>
          )}
          <Typography component="span" sx={{ position: "relative", top: "4px" }}>
            {labelChild}
          </Typography>
        </Typography>
      )}
      {/* {loading && <BackDrop />} */}
      {
        items &&
        <Select
          {...rest}
          sx={height ? { ...root, height, lineHeight: height } : root}
          value={value}
          onChange={onChange} MenuProps={MenuProps}
          displayEmpty
          renderValue={((!value || (rest.multiple && ((value as any[]).length === 0))) && placeholder) ? () => <Typography className="mui-select-placeholder">{placeholder}</Typography> : undefined}
        >
          {items.map((v: any) => (
            <MenuItem key={v.name} value={v.value}>
              {v.name}
            </MenuItem>
          ))}
        </Select>
      }
      {showErrorMessage && (
        <Collapse in={error} sx={{ marginTop: "8px" }}>
          <StyledAlert severity="error" variant="outlined">
            {helperText}
          </StyledAlert>
        </Collapse>
      )}
    </FormControl>
  );
};

export default SelectWithLabel;
